/* Add new component CaseStudyTwoColumnsMainContent */

import React, { useState, useEffect } from 'react';
import style from './CaseStudyTwoColumnsMainContent.module.scss';
import LottieAnimation from '../LottieAnimation';

const CaseStudyTwoColumnsMainContent = component => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load data on component mount
    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                // Simulate API call delay
                await new Promise(resolve => setTimeout(resolve, 100));

                setData(component);
            } catch (error) {
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [component]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return null;
    }

    // Destructure data
    const { leftContents = [], rightContents = [] } = data;

    // Get rightImage from rightContents[0].image
    // get rightImage from rightContents array where type = caseStudyImageNew
    const rightImage = rightContents && rightContents.find(c => { return c.type === 'caseStudyImageNew' });
    const rightStatements = rightContents && rightContents.find(c => { return c.type === 'caseStudyStatementsNew' });

    // TextFormat component for left column content
    const TextFormat = content => {
        return (
            <div className={style.textBlock}>
                {content?.title && <h4 className={style.textTitle}>{content.title}</h4>}
                {content?.body && (
                    <div
                        className={style.textBody}
                        dangerouslySetInnerHTML={{
                            __html: content.body,
                        }}
                    />
                )}
            </div>
        );
    };

    return (
        <div className={[style.caseStudyTwoColumnsMainContent, 'container'].join(' ')}>
            <div className={style.twoColumnLayout}>
                {/* Left Column - Text Content */}
                <div className={style.leftColumn}>
                    <div className={style.leftContent}>
                        {leftContents.map((item, index) => (
                            <TextFormat key={index} {...item} />
                        ))}
                    </div>
                </div>
                {/* Right Column - Image and Statements */}
                <div className={style.rightColumn}>
                    {/* Top Image */}

                    {rightImage && rightImage.image && rightImage.image.url && (
                        <div className={style.rightImage}>
                            <img src={rightImage.image.url} alt={rightImage.image.alt || ''} />
                        </div>
                    )}
                    {/* Statements List */}
                    {rightStatements && rightStatements.statements.length > 0 && (
                        <div className={style.statementsSection}>
                            {/* Statements Title */}
                            {rightStatements && rightStatements.title && (
                                <h3 className={style.statementsTitle}>{rightStatements.title}</h3>
                            )}
                            <div className={style.statementsList}>
                                {rightStatements.statements.map((statement, index) => (
                                    <div key={index} className={style.statementItem}>
                                        <div className={style.statementIcon}>
                                            {statement.animationJson ? (
                                                <LottieAnimation
                                                    json={statement.animationJson}
                                                    playImmediately={false}
                                                />
                                            ) : statement.image && statement.image.url ? (
                                                <img src={statement.image.url} alt={statement.image.alt || ''} />
                                            ) : null}
                                        </div>
                                        {statement.text && (
                                            <div
                                                className={style.statementText}
                                                dangerouslySetInnerHTML={{
                                                    __html: statement.text,
                                                }}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

CaseStudyTwoColumnsMainContent.propTypes = {
    // Component now receives all props directly
};

export default CaseStudyTwoColumnsMainContent;
